import PageWrapper from "../../components/Page/PageWrapper";
import PageTitle from "../../components/Page/PageTitle";
import AdvancedSearchHistoryTable from "./components/advancedSearchHistoryTable/AdvancedSearchHistoryTable";
import { useTranslation } from "react-i18next";

const AdvancedSearchHistoryPage = () => {
  const { t } = useTranslation();

  return (
    <PageWrapper>
      <PageTitle title={t("pageHeaders.advancedSearchHistory")} />
      <AdvancedSearchHistoryTable />
    </PageWrapper>
  );
};

export default AdvancedSearchHistoryPage;
